"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=ComunicaDataFactory.js.map